import React, { useLayoutEffect, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
import { fetchServices } from '../utils/apiService';

// Default fallback image
import img4 from '../assets/image/img-4.jpg';

const ServiceDetails = () => {
    const { id } = useParams();
    const [service, setService] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useLayoutEffect(() => {
        const timer = setTimeout(() => {
            if (window.animationText) window.animationText();
            if (window.scrollingEffect) window.scrollingEffect();
            if (window.animateImgItem) window.animateImgItem();

            if (window.ScrollTrigger) {
                window.ScrollTrigger.refresh();
            }
        }, 800);

        return () => {
            clearTimeout(timer);
            if (window.revertAnimations) window.revertAnimations();
            if (window.revertHeadline) window.revertHeadline();
        };
    }, [service]);

    useEffect(() => {
        const getServiceDetails = async () => {
            setIsLoading(true);
            const result = await fetchServices();
            if (result && result.status && result.data) {
                const found = result.data.find(
                    (item) => String(item.id) === String(id) || item.slug === id
                );
                if (found) {
                    setService(found);
                }
            }
            setIsLoading(false);
        };

        if (id) {
            getServiceDetails();
        }
    }, [id]);

    const getImageUrl = (imgVal) => {
        if (!imgVal) return img4; // Fallback
        const imgStr = imgVal.toString().trim();
        return imgStr.startsWith('http')
            ? imgStr
            : `${process.env.REACT_APP_STORAGE_BASE_URL || 'http://localhost:8000/storage'}/${imgStr}`;
    };

    return (
        <div className="wrapper position-relative">
            <Header />
            <div className="page-title">
                <div className="tf-container">
                    <div className="page-title-content text-center">
                        <h1
                            className="title ml-11"
                            dangerouslySetInnerHTML={{
                                __html: `<span class="split-text effect-right">${isLoading ? 'Loading...' : (service ? service.title : 'Service Not Found')}</span>`
                            }}
                        />
                        <div className="breadkcum">
                            <Link to="/" className="link-breadkcum body-2 fw-7">
                                <span className="split-text effect-right" dangerouslySetInnerHTML={{ __html: 'Home' }} />
                            </Link>
                            <span className="dot"></span>
                            <Link to="/services" className="link-breadkcum body-2 fw-7">
                                <span className="split-text effect-right" dangerouslySetInnerHTML={{ __html: 'Services' }} />
                            </Link>
                            <span className="dot"></span>
                            <span className="page-breadkcum body-2 fw-7">
                                <span className="split-text effect-right" style={{ color: 'var(--primary)' }} dangerouslySetInnerHTML={{ __html: (isLoading ? '...' : (service ? service.title : '')) }} />
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-content">
                <div className="tf-container">
                    <div className="row rg-30">
                        <div className="col-xl-12">
                            <div className="wg-details wg-blog-details mb-60">
                                <div className="details-content">
                                    {isLoading ? (
                                        <div className="text-center py-5">
                                            <p>Loading service details...</p>
                                        </div>
                                    ) : service ? (
                                        <>
                                            <div className="image img-details mb-35 desc mb-20">
                                                <img
                                                    src={getImageUrl(service.image)}
                                                    alt={service.title}
                                                    style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
                                                />
                                            </div>
                                            <div className="desc mb-40 px-lg-15">
                                                <div className="desc-flex flex g-20">
                                                    <span className="lh-30" dangerouslySetInnerHTML={{ __html: service.description }}></span>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="text-center py-5">
                                            <p>Service not found.</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default ServiceDetails;
